import Vue from 'vue'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'
import BugsnagPerformance from '@bugsnag/browser-performance'

Bugsnag.start({
  apiKey: 'c404b402a31b7d8a0ae5a5851b67e578',
  plugins: [new BugsnagPluginVue()]
})

BugsnagPerformance.start({ apiKey: 'c404b402a31b7d8a0ae5a5851b67e578' })

const bugsnagVue = Bugsnag.getPlugin('vue')

bugsnagVue.installVueErrorHandler(Vue)